import { motion } from "framer-motion";
import { ArrowUpRight, ExternalLink } from "lucide-react";
import { SERVICES } from "@/data/services";

function CatalogCard({ service, index }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur transition-colors duration-300 hover:border-white/25"
      data-testid={`showcase-panel-${service.id}`}
    >
      <div className="relative h-44 overflow-hidden rounded-2xl">
        <img
          src={service.image}
          alt={service.name}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(to top, ${service.accentDeep}59, transparent 55%)`,
          }}
        />
        <span
          className="absolute left-3 top-3 rounded-full px-3 py-1 text-[11px] font-bold tracking-wide text-white shadow-lg"
          style={{ background: service.accentDeep }}
        >
          {service.price}
        </span>
      </div>

      <div className="mt-4 flex items-start justify-between gap-3">
        <h3 className="font-display text-xl text-[#F6F0E6]">{service.name}</h3>
        <span className="mt-1 shrink-0 font-mono text-[10px] text-[#F6F0E6]/40">
          {service.url}
        </span>
      </div>

      <a
        href={service.catalogUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`showcase-catalog-${service.id}`}
        className="mt-3 inline-flex items-center gap-2 self-start rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-[box-shadow,transform] duration-200 hover:-translate-y-0.5"
        style={{
          background: service.accentDeep,
          boxShadow: `0 8px 24px -8px ${service.accentDeep}`,
        }}
      >
        Lihat Katalog
        <ExternalLink size={14} />
      </a>

      <div className="mt-5 flex-1 border-t border-white/10 pt-4">
        <p className="font-mono text-[10px] tracking-[0.3em] text-[#F6F0E6]/40">
          CONTOH PORTOFOLIO
        </p>
        <ul className="mt-3 space-y-2">
          {service.examples.map((ex) => (
            <li key={ex.label}>
              {ex.url ? (
                <a
                  href={ex.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`showcase-example-${service.id}-${ex.label
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .slice(0, 30)}`}
                  className="flex items-center gap-2 text-sm text-[#F6F0E6]/75 transition-colors duration-200 hover:text-[#E8C98A]"
                >
                  <ArrowUpRight size={14} style={{ color: service.accent }} />
                  {ex.label}
                </a>
              ) : (
                <span className="flex items-center gap-2 text-sm text-[#F6F0E6]/35">
                  <ArrowUpRight size={14} className="text-[#F6F0E6]/20" />
                  {ex.label}
                  <span className="rounded-full border border-white/15 px-2 py-0.5 text-[9px] tracking-wider">
                    SEGERA
                  </span>
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </motion.article>
  );
}

export default function Showcase() {
  return (
    <section
      id="karya"
      data-testid="showcase-section"
      className="relative bg-[#0B132B] py-24 lg:py-32"
    >
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12 max-w-2xl"
        >
          <p className="font-mono text-[11px] tracking-[0.4em] text-[#C9A227]">
            02 — KATALOG & PORTOFOLIO
          </p>
          <h2 className="font-display mt-3 text-3xl text-[#F6F0E6] md:text-5xl">
            Setiap perayaan, <em className="text-[#E8C98A]">wujudnya</em>{" "}
            berbeda
          </h2>
          <p className="mt-3 max-w-lg text-sm text-[#F6F0E6]/60">
            Semua tautan bisa diklik — buka katalog tiap layanan, atau lihat
            langsung contoh web yang sudah jadi dan dipakai klien.
          </p>
        </motion.div>
        <div
          className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
          data-testid="showcase-track"
        >
          {SERVICES.map((s, i) => (
            <CatalogCard key={s.id} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
